<!-- Menu content with PrimeNG PanelMenu -->
<div class="menu-content" [class.menu-collapsed]="!sidebarExpanded()">
  @if (!authData()?.userType) {
    <p-panelMenu [model]="menuItems()" [multiple]="false" [pt]="panelMenuPT">
    </p-panelMenu>
  }
</div>
